export enum NavigationEntries {
  ChannelSettings = '@trustedshops/tswp-plugin-channel-management:ChannelSettings'
}
